/* eslint-disable operator-linebreak */
/* eslint-disable arrow-parens */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable indent */
/* eslint-disable no-confusing-arrow */
import styled, { css } from 'styled-components';

interface GridProps {
  active: boolean;
}
export const Container = styled.aside`
  grid-area: aside;
  transition: all 0.3s;
  overflow-y: auto;
  background: var(--aside-background);
  transition: width 0.3s ease;

  .menu-icon {
    background: var(--purple);
    color: var(--white);
    font-size: 24px;
  }

  .menu-responsive-icon {
    background: var(--purple);
    color: var(--white);
    font-size: 24px;
    display: none;
  }

  .logo-container {
    display: flex;
    height: 50px;

    justify-content: space-between;
    align-items: center;
    padding: 0 16px;
    background: var(--purple);
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));

    img {
      z-index: 100;
      width: 120px;
      margin: 15px;
    }
  }

  .menu-aside-links {
    margin-top: 20px;
    list-style: none;
    padding: 0 16px;
  }

  .icon-link {
    display: flex;

    svg {
      margin-right: 14px;
    }

    a {
      font-weight: 600;
    }

    &.last {
      margin-bottom: 15px;
    }
  }

  .menu-aside-links a {
    color: var(--white);
    text-decoration: underline !important;
    text-decoration-color: transparent !important;
  }
  .menu-aside-links li a:hover {
    text-decoration: underline;
    text-decoration-color: white !important;
  }

  @media only screen and (min-width: 769px) {
    .aside_close-icon {
      display: none;
    }
  }

  @media only screen and (max-width: 769px) {
    .menu-icon {
      display: none;
    }

    .menu-responsive-icon {
      display: block;
    }
  }
`;

export const AsideMenu = styled.ul`
  list-style: none;
`;

export const AsideItem = styled.li<GridProps>`
  display: flex;
  width: 100%;
  min-height: 60px;
  margin-bottom: 5px;
  background: #d3d8f3;
  border-bottom: 1px solid #ffffff;
  align-items: center;
  padding-left: 33px;
  cursor: pointer;
  transition: all 0.3s ease;

  display: flex;
  align-items: center;

  svg {
    margin-right: 15px;
  }

  .svg {
    width: 38px;
    path {
      fill: var(--purple);
    }
  }

  .link {
    display: flex;
    align-items: center;
    height: 28px;

    font-family: Source Sans Pro;
    font-style: normal;
    font-weight: normal;
    font-size: 17px;
    line-height: 28px;

    color: var(--purple);

    svg {
      width: 20px;
    }
  }

  &.last {
    margin-bottom: 15px;
  }

  &:hover {
    background: white;

    .svg {
      path {
        fill: var(--orange);
      }
    }

    .link {
      color: var(--orange);
    }
  }

  ${props =>
    props.active &&
    css`
      background: white;

      .svg {
        path {
          fill: var(--orange);
        }
      }

      .link {
        color: var(--orange);
      }
    `}
`;

export const ToggledAsideItem = styled.li<GridProps>`
  display: flex;
  width: 100%;
  height: 60px;
  background: #ebf1f4;
  border-bottom: 1px solid #ffffff;
  align-items: center;
  justify-content: center;

  cursor: pointer;
  transition: all 0.3s ease;

  .svg {
    width: 38px;
    path {
      fill: var(--purple);
    }
  }

  .link {
    display: flex;
    align-items: center;
    height: 28px;

    font-family: Source Sans Pro;
    font-style: normal;
    font-weight: normal;
    font-size: 17px;
    line-height: 28px;

    color: var(--purple);

    svg {
      width: 20px;
    }
  }

  &.last {
    margin-bottom: 15px;
  }

  &:hover {
    background: white;

    .svg {
      path {
        fill: var(--orange);
      }
    }

    .link {
      color: var(--orange);
    }
  }

  ${props =>
    props.active &&
    css`
      background: white;

      .svg {
        path {
          fill: var(--orange);
        }
      }

      .link {
        color: var(--orange);
      }
    `}
`;

export const AsideHeader = styled.li`
  background: #d3d8f3;
  border: 1px solid #ffffff;
  min-height: 60px;
  font-family: Roboto Slab;
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 37px;
  color: #452359;

  display: flex;
  padding-left: 33px;
  align-items: center;
`;

export const Separator = styled.li`
  background: #f7d7cc;
  height: 40px;
`;
